// extracted by mini-css-extract-plugin
module.exports = {"container":"splitScreen_container__JLoB5"};